import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";
import type { ProfileResponse } from "api/auth";

// export interface Profile {
//   contact: string;
//   firstName: string;
//   lastName: string;
// }

export interface AuthSliceState {
  isAuth: boolean;
  profile: ProfileResponse;
}

const initialState: AuthSliceState = {
  isAuth: false,
  profile: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<ProfileResponse>) {
      state.profile = action.payload;
    },
    setIsAuth(state, action: PayloadAction<boolean>) {
      state.isAuth = action.payload;
    },
    logout(state) {
      state.profile = {};
      state.isAuth = false;
    }
  },
});

export const { setProfile, setIsAuth, logout } = authSlice.actions;
